import { useState } from "react";

import Button from "@mui/material/Button";

import { useTranslation } from "react-i18next";
import AddDialog from "./Dialog";

const AddRecipient = ({ groupId }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	return (
		<div>
			<Button variant="contained" onClick={handleClickOpen}>
				{t("add_carrier_to_blacklist")}
			</Button>
			<AddDialog open={open} onClose={handleClose} groupId={groupId} />
		</div>
	);
};

export default AddRecipient;
